<div class="auth-modal-container">
  <div class="form-container">
    <ng-container *ngIf="currentState === ForgotPasswordStateEnum.SendEmail">
      <form novalidate
            (submit)="sendEmail()"
            [formGroup]="resetPasswordForm"
      >
        <div class="logo-img"></div>
        <div class="form-header">
          Forgot password?
        </div>
        <div class="form-description bordered">
          No problem. Enter your email and we’ll send you a link to reset your password.
        </div>
        <app-input [type]="'email'"
                   class="reset-password"
                   [label]="'Email'"
                   [autofocus]="true"                
                   formControlName="email"
        ></app-input>

        <app-button customClasses="w-full"
                    class="submit-btn"
                    [disabled]="resetPasswordForm.invalid || (loading$ | async)"
                    [loading]="loading$ | async"
                    [text]="'Send via email'"
                    [type]="'submit'"
        ></app-button>
      </form>
    </ng-container>

    <ng-container *ngIf="currentState === ForgotPasswordStateEnum.EmailIsSent">
      <div class="logo-img"></div>
      <div class="label-success">
        <img class="icon-sent" src="assets/icons/icon-alert-success-blue.svg" alt="icon-success"/>
        Email sent
      </div>
      <div class="form-description confirmed">
        Almost there!  If the email you entered belongs to a valid account, please click the link found in your inbox.
      </div>
    </ng-container>

    <ng-container *ngIf="currentState === ForgotPasswordStateEnum.ResetPassword && showPasswordForm">
      <form novalidate
            (submit)="sendPassword()"
            [formGroup]="newPasswordForm"
      >
        <div class="logo-img"></div>
        <div class="form-header">
          New password
        </div>
        <div class="form-description bordered">
          Please enter a secure password that you can remember but is difficult to guess.
        </div>
        <app-input [type]="'password'"
                   class="reset-password"
                   [label]="'Password'"
                   (keyupEnter)="sendPassword()"
                   formControlName="password"
        ></app-input>

        <app-button customClasses="w-full"
                    class="submit-btn"
                    [text]="'Reset and login'"
                    type="submit"
                    [disabled]="newPasswordForm.invalid"
        ></app-button>
      </form>
    </ng-container>

    <ng-container *ngIf="currentState === ForgotPasswordStateEnum.ResetPassword && showLinkErrors">
      <div class="logo-img"></div>
      <div class="form-description confirmed">
        This link is no longer valid, please try resetting again.
      </div>
    </ng-container>
    
    <ng-container *ngIf="currentState === ForgotPasswordStateEnum.PasswordIsReset">
      <div class="logo-img"></div>
      <div class="label-success">
        <img class="icon-sent" src="assets/icons/icon-alert-success-blue.svg" alt="icon-success"/>
        Password reset
      </div>
      <div class="form-description confirmed">
        You are being redirected.
      </div>
    </ng-container>
  
  </div>
</div>
